/**
 * Base path for Next.js Route Handlers that proxy to Laravel.
 * Must NOT be `/api` when Laravel is deployed under `/api` on the same host — those requests are
 * handled by Laravel/nginx and never reach Next.js (breaking auth and classified proxies).
 */
export function getNextProxyBase(): string {
  const raw = process.env.NEXT_PUBLIC_NEXT_PROXY_BASE?.trim() || '/nx';
  return raw.replace(/\/$/, '') || '/nx';
}
